import React from 'react';
import { Section } from './Section';
import { bonos } from '../data/bonos';
import { BONUS_VALUE } from '../lib/config';
export function Bonuses() {
  return <Section tone="ivory" data-id="element-27" data-mp="pm2eu58fzvl9">
      <div className="flex flex-col items-center text-center" data-id="element-28" data-mp="avcv2egx185s">
        <p className="kicker" data-id="element-29" data-mp="asz5gl508o5m">5 bonos pro incluidos gratis</p>
        <h2 className="mt-6 max-w-[26ch] font-serif text-[28px] leading-tight sm:text-4xl" data-id="element-30" data-mp="ft4ppg8y38do">
          Valor total: {BONUS_VALUE}{' '}
          <span className="text-gold-dark" data-id="element-31" data-mp="1whrzb964e6p">→ gratis</span> con tu Master Plan 15
        </h2>
      </div>

      <ul className="mt-14 flex flex-col gap-6" data-id="element-32" data-mp="5tvyuw9dm9vj">
        {bonos.map((bono, index) => <li key={bono.number} className="card-editorial overflow-hidden" data-id="element-33" data-mp="3o3fz62ow37ly" data-mpi={index}>
            <article className={`grid gap-6 p-6 sm:grid-cols-2 sm:gap-8 sm:p-8 ${index % 2 === 1 ? 'sm:[&>figure]:order-2' : ''}`} data-id="element-34" data-mp="3t1hkku9sfj0l">
              <figure className="m-0" data-id="element-35" data-mp="1r8a25byvolah">
                <img src={bono.image} alt={bono.alt} className="h-full max-h-[220px] w-full rounded-card border border-gold-line object-cover" loading="lazy" data-id="element-36" data-mp="1r78px464lsr6" />
              </figure>

              <div className="flex flex-col justify-center" data-id="element-37" data-mp="3r68eh4kfqy0o">
                <p className="kicker" data-id="element-38" data-mp="3n4mvr2l7zpik">{bono.number}</p>
                <h3 className="mt-3 font-serif text-2xl leading-tight" data-id="element-39" data-mp="3n79dfv1trlei">
                  {bono.title}
                </h3>

                <p className="mt-3 flex items-center gap-2 text-sm" data-id="element-40" data-mp="2ughb0fu620iq">
                  <span className="text-ink-muted line-through" data-id="element-41" data-mp="2uibtzolvnik6">
                    {bono.price}
                  </span>
                  <span className="rounded-card bg-gold-tint px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-gold-dark" data-id="element-42" data-mp="33h5nv77tpuu1">
                    Gratis
                  </span>
                </p>

                <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-43" data-mp="ir6rlv055a79">
                  {bono.body}
                </p>
                <p className="mt-4 font-serif text-base italic text-gold-dark" data-id="element-44" data-mp="3chv6dti75io8">
                  {bono.kicker}
                </p>
              </div>
            </article>
          </li>)}
      </ul>
    </Section>;
}